import colors from 'styles/theme/colors';

export default function SummaryFailedIcon({ width = 80, height = 80, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='40' cy='40' r='40' fill={colors.purple100} fillOpacity='0.1' />
      <g clipPath='url(#clip0_5700_2037)'>
        <path
          d='M33 35.3333H45.6667'
          stroke={colors.purple100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33 39.3333H45.6667'
          stroke={colors.purple100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33 31.3333H42.3333'
          stroke={colors.purple100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33 43.3333H42.3333'
          stroke={colors.purple100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33 47.3333H39'
          stroke={colors.purple100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M38.3334 55.3334H29.0001C28.6465 55.3334 28.3073 55.1928 28.0573 54.9428C27.8072 54.6928 27.6667 54.3536 27.6667 54V26C27.6667 25.6464 27.8072 25.3073 28.0573 25.0572C28.3073 24.8072 28.6465 24.6667 29.0001 24.6667H46.7241C47.0777 24.6668 47.4167 24.8073 47.6667 25.0574L52.6094 30C52.8595 30.25 52.9999 30.5891 53.0001 30.9427V35.3334'
          stroke={colors.purple100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M50.3333 48.6667V44.6667'
          stroke={colors.red100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M51.4506 40.6666C51.3425 40.4642 51.1816 40.295 50.9848 40.177C50.788 40.0589 50.5628 39.9966 50.3333 39.9966C50.1038 39.9966 49.8786 40.0589 49.6818 40.177C49.4852 40.295 49.3241 40.4642 49.216 40.6666L42.4746 53.5133C42.375 53.7025 42.3265 53.9144 42.3337 54.1281C42.341 54.3418 42.4038 54.55 42.516 54.732C42.6296 54.9149 42.7881 55.0658 42.9764 55.1704C43.1646 55.275 43.3766 55.3297 43.592 55.3293H57.0746C57.29 55.3297 57.502 55.275 57.6902 55.1704C57.8785 55.0658 58.037 54.9149 58.1506 54.732C58.2628 54.55 58.3256 54.3418 58.3329 54.1281C58.3401 53.9144 58.2916 53.7025 58.192 53.5133L51.4506 40.6666Z'
          stroke={colors.red100}
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M50.3333 52C50.1492 52 50 51.8508 50 51.6666C50 51.4825 50.1492 51.3333 50.3333 51.3333'
          stroke={colors.red100}
          strokeWidth='1.33333'
        />
        <path
          d='M50.3333 52C50.5174 52 50.6666 51.8508 50.6666 51.6666C50.6666 51.4825 50.5174 51.3333 50.3333 51.3333'
          stroke={colors.red100}
          strokeWidth='1.33333'
        />
      </g>
      <defs>
        <clipPath id='clip0_5700_2037'>
          <rect width='32' height='32' fill='white' transform='translate(27 24)' />
        </clipPath>
      </defs>
    </svg>
  );
}
